(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-form-loader"] = factory();
	else
		root["vue-form-loader"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.index = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.install = install;
    var options = {
        loadingClass: 'is-loading',
        disabledClass: 'is-disabled'
    };

    var addLoaderToSubmit = function addLoaderToSubmit(submit, onlyOneSubmit) {
        // Only add a loading class to the clicked button unless it's just one
        // button. This enabled the loading class to be added to a form with
        // only one button if the user pressed enter when in a text input
        if (onlyOneSubmit || document.activeElement === submit) {
            submit.classList.add(options.loadingClass);
        }

        // A submit button with a name cannot be disabled since
        // then we can't check if the specific button was pressed server side
        if (submit.hasAttribute('name')) {
            submit.classList.add(options.disabledClass);
        } else {
            submit.disabled = true;
        }
    };

    var removeLoaderFromSubmit = function removeLoaderFromSubmit(submit) {
        submit.classList.remove(options.loadingClass);
        submit.classList.remove(options.disabledClass);
        submit.disabled = false;
    };

    var bindEventToForm = function bindEventToForm(form) {
        form.addEventListener('submit', function () {
            var submits = form.querySelectorAll('[type="submit"]');
            var onlyOneSubmit = submits.length <= 1;
            Array.from(submits).forEach(function (submit) {
                addLoaderToSubmit(submit, onlyOneSubmit);
            });
        });
    };

    var FormLoaderDirective = {
        // Usage: <form v-loading>
        bind: function bind(form, binding) {
            bindEventToForm(form);
        },
        // Usage: <form v-loading="loading">
        update: function update(form, binding) {
            Array.from(form.querySelectorAll('[type="submit"]')).forEach(function (submit) {
                if (binding.value) {
                    addLoaderToSubmit(submit);
                } else {
                    removeLoaderFromSubmit(submit);
                }
            });
        }
    };

    function install(Vue) {
        if (install.installed) return;
        install.installed = true;

        Vue.directive('loading', FormLoaderDirective);
    }

    var FormLoader = {
        install: install,
        autoBindToForms: function autoBindToForms() {
            Array.from(document.querySelectorAll('form')).forEach(function (form) {
                bindEventToForm(form);
            });
        },
        set loadingClass(value) {
            options.loadingClass = value;
        },
        set disabledClass(value) {
            options.disabledClass = value;
        }
    };

    var GlobalVue = null;
    if (typeof window !== 'undefined') {
        GlobalVue = window.Vue;
    } else if (typeof global !== 'undefined') {
        GlobalVue = global.Vue;
    }
    if (GlobalVue) {
        GlobalVue.use(FormLoader);
    }

    exports.default = FormLoader;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ })
/******/ ]);
});